export const VALID_URL_PROTOCOLS = ['http://', 'https://'];
